/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { FxGamesLibWebRpcContractsFxGamesResponseOfCheckBuyProductsResponseFromJSON, FxGamesLibWebRpcContractsFxGamesResponseOfSuccessFromJSON, FxGamesLibWebRpcContractsResponseFromJSON, FxIdApplicationHandlersStoreUpdateOrderPIHandlerUpdateOrderPersonalInfoCommandToJSON, FxIdApplicationOrdersOrdersSetOptimisticOrderStatusCommandToJSON, FxIdApplicationStoreAghanimDtosAghanimPaymentStatusDtoFromJSON, FxIdApplicationStoreCheckBuyProductsCheckBuyProductsRequestToJSON, FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFromJSON, FxIdApplicationStorePlutusGetPlutusPaymentStatusQueryResponseFromJSON, FxIdWebFeaturesStoreContinueRedirectWithPiRequestToJSON, FxIdWebFeaturesStoreContinueRedirectWithPiResponseFromJSON, FxIdWebFeaturesStoreCreatePaymentRequestToJSON, FxIdWebFeaturesStoreGetPaymentStatusRequestToJSON, FxIdWebFeaturesStoreGetPaymentStatusResponseFromJSON, FxIdWebFeaturesStoreGetPiFormDataRequestToJSON, FxIdWebFeaturesStoreGetPiFormDataResponseFromJSON, FxIdWebFeaturesStoreMerchantPaymentCompletedRedirectRequestToJSON, FxIdWebFeaturesStoreMerchantPaymentCompletedRedirectResponseFromJSON, FxIdWebFeaturesStoreStoreAvailabilityResponseFromJSON, FxIdWebFeaturesStoreStoreDataRequestToJSON, FxIdWebFeaturesStoreStoreDataResponseFromJSON, } from '../models/index';
/**
 *
 */
export class StoreApi extends runtime.BaseAPI {
    /**
     */
    async fxIdWebFeaturesStoreAghanimPaymentStatusPaymentStatusEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['publicOrderId'] == null) {
            throw new runtime.RequiredError('publicOrderId', 'Required parameter "publicOrderId" was null or undefined when calling fxIdWebFeaturesStoreAghanimPaymentStatusPaymentStatusEndpoint().');
        }
        const queryParameters = {};
        if (requestParameters['publicOrderId'] != null) {
            queryParameters['PublicOrderId'] = requestParameters['publicOrderId'];
        }
        const headerParameters = {};
        const response = await this.request({
            path: `/api/v1/store/aghanim/payment/status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdApplicationStoreAghanimDtosAghanimPaymentStatusDtoFromJSON(jsonValue));
    }
    /**
     */
    async fxIdWebFeaturesStoreAghanimPaymentStatusPaymentStatusEndpoint(publicOrderId, initOverrides) {
        const response = await this.fxIdWebFeaturesStoreAghanimPaymentStatusPaymentStatusEndpointRaw({ publicOrderId: publicOrderId }, initOverrides);
        return await response.value();
    }
    /**
     */
    async fxIdWebFeaturesStoreCheckBuyProductsCheckBuyProductsEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['fxIdApplicationStoreCheckBuyProductsCheckBuyProductsRequest'] == null) {
            throw new runtime.RequiredError('fxIdApplicationStoreCheckBuyProductsCheckBuyProductsRequest', 'Required parameter "fxIdApplicationStoreCheckBuyProductsCheckBuyProductsRequest" was null or undefined when calling fxIdWebFeaturesStoreCheckBuyProductsCheckBuyProductsEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/store/check-buy-products`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdApplicationStoreCheckBuyProductsCheckBuyProductsRequestToJSON(requestParameters['fxIdApplicationStoreCheckBuyProductsCheckBuyProductsRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxGamesLibWebRpcContractsFxGamesResponseOfCheckBuyProductsResponseFromJSON(jsonValue));
    }
    /**
     */
    async fxIdWebFeaturesStoreCheckBuyProductsCheckBuyProductsEndpoint(fxIdApplicationStoreCheckBuyProductsCheckBuyProductsRequest, initOverrides) {
        const response = await this.fxIdWebFeaturesStoreCheckBuyProductsCheckBuyProductsEndpointRaw({ fxIdApplicationStoreCheckBuyProductsCheckBuyProductsRequest: fxIdApplicationStoreCheckBuyProductsCheckBuyProductsRequest }, initOverrides);
        return await response.value();
    }
    /**
     * Это роут для поддержки сбора персональных данных пользователя при работе через FxNative и CreatePaymentWithRedirect
     */
    async fxIdWebFeaturesStoreContinueRedirectWithPiEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['fxIdWebFeaturesStoreContinueRedirectWithPiRequest'] == null) {
            throw new runtime.RequiredError('fxIdWebFeaturesStoreContinueRedirectWithPiRequest', 'Required parameter "fxIdWebFeaturesStoreContinueRedirectWithPiRequest" was null or undefined when calling fxIdWebFeaturesStoreContinueRedirectWithPiEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/store/continue_redirect_with_pi`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesStoreContinueRedirectWithPiRequestToJSON(requestParameters['fxIdWebFeaturesStoreContinueRedirectWithPiRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesStoreContinueRedirectWithPiResponseFromJSON(jsonValue));
    }
    /**
     * Это роут для поддержки сбора персональных данных пользователя при работе через FxNative и CreatePaymentWithRedirect
     */
    async fxIdWebFeaturesStoreContinueRedirectWithPiEndpoint(fxIdWebFeaturesStoreContinueRedirectWithPiRequest, initOverrides) {
        const response = await this.fxIdWebFeaturesStoreContinueRedirectWithPiEndpointRaw({ fxIdWebFeaturesStoreContinueRedirectWithPiRequest: fxIdWebFeaturesStoreContinueRedirectWithPiRequest }, initOverrides);
        return await response.value();
    }
    /**
     * **MUTATES:** `bank131account`, `bank131order`, `orders`, `orderproduct`, `account_order_settings`, `accounts`  Start payment
     */
    async fxIdWebFeaturesStoreCreatePaymentEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['fxIdWebFeaturesStoreCreatePaymentRequest'] == null) {
            throw new runtime.RequiredError('fxIdWebFeaturesStoreCreatePaymentRequest', 'Required parameter "fxIdWebFeaturesStoreCreatePaymentRequest" was null or undefined when calling fxIdWebFeaturesStoreCreatePaymentEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/store/create_payment`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesStoreCreatePaymentRequestToJSON(requestParameters['fxIdWebFeaturesStoreCreatePaymentRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFromJSON(jsonValue));
    }
    /**
     * **MUTATES:** `bank131account`, `bank131order`, `orders`, `orderproduct`, `account_order_settings`, `accounts`  Start payment
     */
    async fxIdWebFeaturesStoreCreatePaymentEndpoint(fxIdWebFeaturesStoreCreatePaymentRequest, initOverrides) {
        const response = await this.fxIdWebFeaturesStoreCreatePaymentEndpointRaw({ fxIdWebFeaturesStoreCreatePaymentRequest: fxIdWebFeaturesStoreCreatePaymentRequest }, initOverrides);
        return await response.value();
    }
    /**
     * **MUTATES:** `bank131account`, `bank131order`, `orders`, `orderproduct`, `account_order_settings`, `accounts`  Start payment with redirect
     */
    async fxIdWebFeaturesStoreCreatePaymentWithRedirectEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['game'] == null) {
            throw new runtime.RequiredError('game', 'Required parameter "game" was null or undefined when calling fxIdWebFeaturesStoreCreatePaymentWithRedirectEndpoint().');
        }
        if (requestParameters['sku'] == null) {
            throw new runtime.RequiredError('sku', 'Required parameter "sku" was null or undefined when calling fxIdWebFeaturesStoreCreatePaymentWithRedirectEndpoint().');
        }
        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError('token', 'Required parameter "token" was null or undefined when calling fxIdWebFeaturesStoreCreatePaymentWithRedirectEndpoint().');
        }
        if (requestParameters['webPublishingPlatform'] == null) {
            throw new runtime.RequiredError('webPublishingPlatform', 'Required parameter "webPublishingPlatform" was null or undefined when calling fxIdWebFeaturesStoreCreatePaymentWithRedirectEndpoint().');
        }
        const queryParameters = {};
        if (requestParameters['token'] != null) {
            queryParameters['Token'] = requestParameters['token'];
        }
        if (requestParameters['currency'] != null) {
            queryParameters['Currency'] = requestParameters['currency'];
        }
        if (requestParameters['country'] != null) {
            queryParameters['Country'] = requestParameters['country'];
        }
        if (requestParameters['countryHint'] != null) {
            queryParameters['CountryHint'] = requestParameters['countryHint'];
        }
        if (requestParameters['webPublishingPlatform'] != null) {
            queryParameters['WebPublishingPlatform'] = requestParameters['webPublishingPlatform'];
        }
        if (requestParameters['developerPayload'] != null) {
            queryParameters['DeveloperPayload'] = requestParameters['developerPayload'];
        }
        if (requestParameters['productNameHint'] != null) {
            queryParameters['ProductNameHint'] = requestParameters['productNameHint'];
        }
        if (requestParameters['productDescriptionHint'] != null) {
            queryParameters['ProductDescriptionHint'] = requestParameters['productDescriptionHint'];
        }
        const headerParameters = {};
        const response = await this.request({
            path: `/api/v1/store/create_payment_with_redirect/{Game}/{Sku}`.replace(`{${"Game"}}`, encodeURIComponent(String(requestParameters['game']))).replace(`{${"Sku"}}`, encodeURIComponent(String(requestParameters['sku']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * **MUTATES:** `bank131account`, `bank131order`, `orders`, `orderproduct`, `account_order_settings`, `accounts`  Start payment with redirect
     */
    async fxIdWebFeaturesStoreCreatePaymentWithRedirectEndpoint(game, sku, token, webPublishingPlatform, currency, country, countryHint, developerPayload, productNameHint, productDescriptionHint, initOverrides) {
        await this.fxIdWebFeaturesStoreCreatePaymentWithRedirectEndpointRaw({ game: game, sku: sku, token: token, webPublishingPlatform: webPublishingPlatform, currency: currency, country: country, countryHint: countryHint, developerPayload: developerPayload, productNameHint: productNameHint, productDescriptionHint: productDescriptionHint }, initOverrides);
    }
    /**
     */
    async fxIdWebFeaturesStoreGetPaymentStatusEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['fxIdWebFeaturesStoreGetPaymentStatusRequest'] == null) {
            throw new runtime.RequiredError('fxIdWebFeaturesStoreGetPaymentStatusRequest', 'Required parameter "fxIdWebFeaturesStoreGetPaymentStatusRequest" was null or undefined when calling fxIdWebFeaturesStoreGetPaymentStatusEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/store/get_payment_status`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesStoreGetPaymentStatusRequestToJSON(requestParameters['fxIdWebFeaturesStoreGetPaymentStatusRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesStoreGetPaymentStatusResponseFromJSON(jsonValue));
    }
    /**
     */
    async fxIdWebFeaturesStoreGetPaymentStatusEndpoint(fxIdWebFeaturesStoreGetPaymentStatusRequest, initOverrides) {
        const response = await this.fxIdWebFeaturesStoreGetPaymentStatusEndpointRaw({ fxIdWebFeaturesStoreGetPaymentStatusRequest: fxIdWebFeaturesStoreGetPaymentStatusRequest }, initOverrides);
        return await response.value();
    }
    /**
     * Эндпоинт для получения данных формы персональной информации по публичному ID заказа
     */
    async fxIdWebFeaturesStoreGetPiFormDataEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['fxIdWebFeaturesStoreGetPiFormDataRequest'] == null) {
            throw new runtime.RequiredError('fxIdWebFeaturesStoreGetPiFormDataRequest', 'Required parameter "fxIdWebFeaturesStoreGetPiFormDataRequest" was null or undefined when calling fxIdWebFeaturesStoreGetPiFormDataEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/store/pi_form_data`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesStoreGetPiFormDataRequestToJSON(requestParameters['fxIdWebFeaturesStoreGetPiFormDataRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesStoreGetPiFormDataResponseFromJSON(jsonValue));
    }
    /**
     * Эндпоинт для получения данных формы персональной информации по публичному ID заказа
     */
    async fxIdWebFeaturesStoreGetPiFormDataEndpoint(fxIdWebFeaturesStoreGetPiFormDataRequest, initOverrides) {
        const response = await this.fxIdWebFeaturesStoreGetPiFormDataEndpointRaw({ fxIdWebFeaturesStoreGetPiFormDataRequest: fxIdWebFeaturesStoreGetPiFormDataRequest }, initOverrides);
        return await response.value();
    }
    /**
     */
    async fxIdWebFeaturesStoreMerchantPaymentCompletedRedirectEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['fxIdWebFeaturesStoreMerchantPaymentCompletedRedirectRequest'] == null) {
            throw new runtime.RequiredError('fxIdWebFeaturesStoreMerchantPaymentCompletedRedirectRequest', 'Required parameter "fxIdWebFeaturesStoreMerchantPaymentCompletedRedirectRequest" was null or undefined when calling fxIdWebFeaturesStoreMerchantPaymentCompletedRedirectEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/api/v1/store/merchant_payment_completed`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesStoreMerchantPaymentCompletedRedirectRequestToJSON(requestParameters['fxIdWebFeaturesStoreMerchantPaymentCompletedRedirectRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesStoreMerchantPaymentCompletedRedirectResponseFromJSON(jsonValue));
    }
    /**
     */
    async fxIdWebFeaturesStoreMerchantPaymentCompletedRedirectEndpoint(fxIdWebFeaturesStoreMerchantPaymentCompletedRedirectRequest, initOverrides) {
        const response = await this.fxIdWebFeaturesStoreMerchantPaymentCompletedRedirectEndpointRaw({ fxIdWebFeaturesStoreMerchantPaymentCompletedRedirectRequest: fxIdWebFeaturesStoreMerchantPaymentCompletedRedirectRequest }, initOverrides);
        return await response.value();
    }
    /**
     * **MUTATES:** `orders`  Sets optimistic order status
     */
    async fxIdWebFeaturesStoreOrdersSetOptimisticOrderStatusSetOptimisticOrderStatusEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['fxIdApplicationOrdersOrdersSetOptimisticOrderStatusCommand'] == null) {
            throw new runtime.RequiredError('fxIdApplicationOrdersOrdersSetOptimisticOrderStatusCommand', 'Required parameter "fxIdApplicationOrdersOrdersSetOptimisticOrderStatusCommand" was null or undefined when calling fxIdWebFeaturesStoreOrdersSetOptimisticOrderStatusSetOptimisticOrderStatusEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/store/set-optimistic-order-status`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdApplicationOrdersOrdersSetOptimisticOrderStatusCommandToJSON(requestParameters['fxIdApplicationOrdersOrdersSetOptimisticOrderStatusCommand']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxGamesLibWebRpcContractsFxGamesResponseOfSuccessFromJSON(jsonValue));
    }
    /**
     * **MUTATES:** `orders`  Sets optimistic order status
     */
    async fxIdWebFeaturesStoreOrdersSetOptimisticOrderStatusSetOptimisticOrderStatusEndpoint(fxIdApplicationOrdersOrdersSetOptimisticOrderStatusCommand, initOverrides) {
        const response = await this.fxIdWebFeaturesStoreOrdersSetOptimisticOrderStatusSetOptimisticOrderStatusEndpointRaw({ fxIdApplicationOrdersOrdersSetOptimisticOrderStatusCommand: fxIdApplicationOrdersOrdersSetOptimisticOrderStatusCommand }, initOverrides);
        return await response.value();
    }
    /**
     */
    async fxIdWebFeaturesStorePlutusPaymentStatusPaymentStatusEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['publicOrderId'] == null) {
            throw new runtime.RequiredError('publicOrderId', 'Required parameter "publicOrderId" was null or undefined when calling fxIdWebFeaturesStorePlutusPaymentStatusPaymentStatusEndpoint().');
        }
        const queryParameters = {};
        if (requestParameters['publicOrderId'] != null) {
            queryParameters['PublicOrderId'] = requestParameters['publicOrderId'];
        }
        const headerParameters = {};
        const response = await this.request({
            path: `/api/v1/store/plutus/payment/status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdApplicationStorePlutusGetPlutusPaymentStatusQueryResponseFromJSON(jsonValue));
    }
    /**
     */
    async fxIdWebFeaturesStorePlutusPaymentStatusPaymentStatusEndpoint(publicOrderId, initOverrides) {
        const response = await this.fxIdWebFeaturesStorePlutusPaymentStatusPaymentStatusEndpointRaw({ publicOrderId: publicOrderId }, initOverrides);
        return await response.value();
    }
    /**
     */
    async fxIdWebFeaturesStoreStoreAvailabilityEndpointRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/api/v1/store/store_availability`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesStoreStoreAvailabilityResponseFromJSON(jsonValue));
    }
    /**
     */
    async fxIdWebFeaturesStoreStoreAvailabilityEndpoint(initOverrides) {
        const response = await this.fxIdWebFeaturesStoreStoreAvailabilityEndpointRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async fxIdWebFeaturesStoreStoreDataEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['fxIdWebFeaturesStoreStoreDataRequest'] == null) {
            throw new runtime.RequiredError('fxIdWebFeaturesStoreStoreDataRequest', 'Required parameter "fxIdWebFeaturesStoreStoreDataRequest" was null or undefined when calling fxIdWebFeaturesStoreStoreDataEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/api/v1/store/store_data`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesStoreStoreDataRequestToJSON(requestParameters['fxIdWebFeaturesStoreStoreDataRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesStoreStoreDataResponseFromJSON(jsonValue));
    }
    /**
     */
    async fxIdWebFeaturesStoreStoreDataEndpoint(fxIdWebFeaturesStoreStoreDataRequest, initOverrides) {
        const response = await this.fxIdWebFeaturesStoreStoreDataEndpointRaw({ fxIdWebFeaturesStoreStoreDataRequest: fxIdWebFeaturesStoreStoreDataRequest }, initOverrides);
        return await response.value();
    }
    /**
     * **MUTATES:** `orders`  Sets order\'s PI
     */
    async fxIdWebFeaturesStoreUpdateOrderPISendSupportMessageEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['fxIdApplicationHandlersStoreUpdateOrderPIHandlerUpdateOrderPersonalInfoCommand'] == null) {
            throw new runtime.RequiredError('fxIdApplicationHandlersStoreUpdateOrderPIHandlerUpdateOrderPersonalInfoCommand', 'Required parameter "fxIdApplicationHandlersStoreUpdateOrderPIHandlerUpdateOrderPersonalInfoCommand" was null or undefined when calling fxIdWebFeaturesStoreUpdateOrderPISendSupportMessageEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/store/update-order-pi`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdApplicationHandlersStoreUpdateOrderPIHandlerUpdateOrderPersonalInfoCommandToJSON(requestParameters['fxIdApplicationHandlersStoreUpdateOrderPIHandlerUpdateOrderPersonalInfoCommand']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxGamesLibWebRpcContractsResponseFromJSON(jsonValue));
    }
    /**
     * **MUTATES:** `orders`  Sets order\'s PI
     */
    async fxIdWebFeaturesStoreUpdateOrderPISendSupportMessageEndpoint(fxIdApplicationHandlersStoreUpdateOrderPIHandlerUpdateOrderPersonalInfoCommand, initOverrides) {
        const response = await this.fxIdWebFeaturesStoreUpdateOrderPISendSupportMessageEndpointRaw({ fxIdApplicationHandlersStoreUpdateOrderPIHandlerUpdateOrderPersonalInfoCommand: fxIdApplicationHandlersStoreUpdateOrderPIHandlerUpdateOrderPersonalInfoCommand }, initOverrides);
        return await response.value();
    }
}
//# sourceMappingURL=StoreApi.js.map